module.exports = __webpack_public_path__ + "static/img/4.84ffb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/4.png
// module id = rvjL
// module chunks = 4